import React, { useEffect, useState } from 'react';
import Access from '../../Components/Access';
import Navbar from '../../Components/Navbar';
import { useForm } from "react-hook-form";
import { getyears } from "../../Components/Tools";
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import axios from 'axios';
import qs from 'qs';
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';

const TauxAnnuel = (props) =>
{
    const [aff, setAff] = useState(false);
    const [objet, setObjet] = useState(false);
    const [yearStart, setYearStart] = useState('');
    const [yearEnd, setYearEnd] = useState('');


    const green = '#59B44A';
    const purple = '#6571FE';

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }
        else
        {
            // Récupération du taux annuel par année
            axios.post("https://app-slfinance.fr/api/taux_annuel.php", qs.stringify({
                'get': true,
                'id_organisme': props.user.id_organisme
            }))
            .then((res) => {
                // Compléter les années manquantes
                let completeData = [];
                if (res.data && res.data.length > 0) {
                    // Trier les données par année
                    const sortedData = res.data.sort((a, b) => parseInt(a[0]) - parseInt(b[0]));
                    
                    for (let i = 0; i < sortedData.length; i++) {
                        completeData.push(sortedData[i]);
                        
                        // Si ce n'est pas la dernière année, vérifier les années manquantes
                        if (i < sortedData.length - 1) {
                            const currentYear = parseInt(sortedData[i][0]);
                            const nextYear = parseInt(sortedData[i + 1][0]);
                            
                            // Ajouter les années manquantes entre les deux
                            for (let year = currentYear + 1; year < nextYear; year++) {
                                completeData.push([year, '0']);
                            }
                        }
                    }
                }
                
                setObjet(completeData);
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }, [props.user])


    const handleTauxChange = (year, value) => {
        var tmp = [];
        objet.forEach((element, i) => {
            if (parseInt(element[0]) >= parseInt(year)) {
                tmp[i] = [element[0], value];
            }
            else {
                tmp[i] = element;
            }
        });
        setObjet(tmp);
        setAff(!aff);
    };


    const handleYearRangeChange = () => {
        const start = parseInt(yearStart);
        const end = parseInt(yearEnd);
        
        if (isNaN(start) || isNaN(end) || start > end) {
            NotificationManager.warning('Plage d\'années invalide', '', 2000);
            return;
        }
        
        // Créer une nouvelle liste vierge

        var newList = [];
        for (let year = start; year <= end; year++) {
            // Vérifier si l'année existe déjà dans l'objet actuel (en comparant en nombre)
            const existing = objet.find(item => parseInt(item[0]) === year);
            if (existing) {
                newList.push(existing); // Conserver la valeur existante
            }
            else {
                newList.push([year, '0']);
            }
        }
        
        setObjet(newList);
        NotificationManager.success('Plage d\'années mise à jour', '', 500);
        setYearStart('');
        setYearEnd('');
    };


    const saveChanges = () => {
        var tmp = [];
        var i = 0;
        for (var elem in objet) {
            tmp[i] = [objet[elem][0], objet[elem][1]];
            i++;
        }
        axios.post("https://app-slfinance.fr/api/taux_annuel.php", qs.stringify({
            'update': true,
            'id_organisme': props.user.id_organisme,
            'objet': tmp
        }))
        .then((res) => {
            if (res.data['status'] === 1) {
                NotificationManager.success(res.data['status_message'], '', 500);
                setTimeout(() => window.location = window.location.href, 600);
            }
            else {
                NotificationManager.warning(res.data['status_message'], '', 3000);
            }
        })
        .catch((err) => {
            console.warn(err)
        })
    }


	return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />


                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Taux annuel</p>
                </div>

                <div className='shadow-md' style={{borderRadius: 3, padding: 20, margin: 25, backgroundColor: 'white'}}>

                    <div>
                        <p style={{textAlign: 'center', color: purple}}>Renseignez la plage d'années voulue</p>
                        {/* Sélection de la plage d'années */}
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 25, marginBottom: 25, gap: 15}}>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <label style={{fontSize: 12, fontWeight: 'bold', marginBottom: 5, color: purple, textAlign: 'center'}}>Année début</label>
                                <input 
                                    value={yearStart}
                                    onChange={(e) => {
                                        let value = parseInt(e.target.value);
                                        setYearStart(isNaN(value) ? '' : value);
                                    }}
                                    placeholder={objet && objet.length > 0 ? String(objet[0][0]) : "2020"}
                                    style={{
                                        border: `1px solid #E9ECEF`,
                                        borderRadius: 5,
                                        padding: '8px 12px',
                                        fontSize: 14,
                                        width: 120
                                    }}
                                />
                            </div>
                            
                            <p style={{margin: '20px 0 0 0'}}>à</p>
                            
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <label style={{fontSize: 12, fontWeight: 'bold', marginBottom: 5, color: purple, textAlign: 'center'}}>Année fin</label>
                                <input 
                                    value={yearEnd}
                                    onChange={(e) => {
                                        let value = parseInt(e.target.value);
                                        setYearEnd(isNaN(value) ? '' : value);
                                    }}
                                    placeholder={objet && objet.length > 0 ? String(objet[objet.length - 1][0]) : "2025"}
                                    style={{
                                        border: `1px solid #E9ECEF`,
                                        borderRadius: 5,
                                        padding: '8px 12px',
                                        fontSize: 14,
                                        width: 120
                                    }}
                                />
                            </div>

                            <button 
                                onClick={handleYearRangeChange}
                                style={{
                                    display: 'flex', 
                                    color: 'white', 
                                    backgroundColor: purple, 
                                    borderRadius: 5, 
                                    padding: '8px 15px',
                                    fontSize: 14,
                                    border: 'none',
                                    cursor: 'pointer',
                                    marginTop: 20,
                                    alignItems: 'center'
                                }}
                            >
                                Valider
                            </button>
                        </div>

                        {/* En-têtes du tableau */}
                        <div style={{display: 'flex', marginTop: 50, marginBottom: 10, borderBottom: `2px solid ${purple}`, paddingBottom: 10, justifyContent: 'center'}}>
                            <div style={{flex: 0.2, fontWeight: 'bold', color: purple, textAlign: 'center'}}>Année</div>
                            <div style={{flex: 0.2, fontWeight: 'bold', color: purple, textAlign: 'center'}}>Taux (%)</div>
                        </div>

                        {/* Contenu du tableau */}
                        <div style={{flex: 1}}>
                            {objet && objet.length > 0 ?
                            objet.map((annee, index) =>
                            <div key={annee[0]} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px 0', borderBottom: `1px solid #E9ECEF`, backgroundColor: index % 2 === 0 ? '#FAFAFA' : 'white'}}>
                                <div style={{flex: 0.2, fontSize: 14, textAlign: 'center'}}>
                                    <p style={{margin: 0, fontWeight: 'bold'}}>{annee[0]}</p>
                                </div>
                                
                                <div style={{flex: 0.2, textAlign: 'center'}}>
                                    <input 
                                        style={{
                                            width: '100%',
                                            maxWidth: 120, 
                                            border: `1px solid #E9ECEF`, 
                                            borderRadius: 5, 
                                            padding: '8px 12px',
                                            fontSize: 14,
                                            textAlign: 'center'
                                        }} 
                                        placeholder={parseFloat(annee[1]).toFixed(2) + '%'} 
                                        onBlur={(e) => {
                                            if (e.target.value !== '' && !isNaN(parseFloat(e.target.value))) {
                                                handleTauxChange(annee[0], e.target.value)
                                            }
                                            e.target.value = '';
                                        }}
                                    />
                                </div>
                            </div>
                            ):
                            <div style={{padding: 20, textAlign: 'center', color: '#999'}}>
                                <p>Aucun taux trouvé</p>
                            </div>
                            }
                        </div>

                        <div style={{margin: 20, marginTop: 30, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                            <button 
                                onClick={saveChanges}
                                style={{display: 'flex', color: 'white', backgroundColor: green, borderRadius: 5, paddingLeft: 10, cursor: 'pointer', border: 'none', padding: '8px 15px', alignItems: 'center'}}
                            >
                                <Check width="12" />
                                <span style={{marginLeft: 5, fontSize: 14, paddingRight: 10}}>Valider</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Access>
        </div>
	);
}

export default TauxAnnuel;
